// Sparkles Large Icon SVG (24x24)
const sparklesLargeSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="24px" width="24px">
    <defs>
        <style>.cls-1{fill:currentColor;stroke-width:0px;}</style>
    </defs>
    <path
        class="cls-1"
        d="M21.05,6.45l2.56.99c.52.2.52.93,0,1.13l-2.56.99-.99,2.56c-.2.52-.93.52-1.13,0l-.99-2.56-2.56-.99c-.52-.2-.52-.93,0-1.13l2.56-.99.99-2.56c.2-.52.93-.52,1.13,0l.99,2.56Z"
    />
    <path
        class="cls-1"
        d="M14.36,1.96l1.71.66c.35.13.35.62,0,.76l-1.71.66-.66,1.71c-.13.35-.62.35-.76,0l-.66-1.71-1.71-.66c-.35-.13-.35-.62,0-.76l1.71-.66.66-1.71c.13-.35.62-.35.76,0l.66,1.71Z"
    />
    <path
        class="cls-1"
        d="M9,24c-.77,0-1.44-.5-1.66-1.24l-1.4-4.7-4.7-1.4c-.74-.22-1.24-.89-1.24-1.66s.5-1.44,1.24-1.66l4.7-1.4,1.4-4.7c.22-.74.89-1.24,1.66-1.24s1.44.5,1.66,1.24l1.4,4.7,4.7,1.4c.74.22,1.24.89,1.24,1.66s-.5,1.44-1.24,1.66l-4.7,1.4-1.4,4.7c-.22.74-.89,1.24-1.66,1.24ZM2.66,15l3.98,1.19c.56.17,1,.6,1.17,1.16l1.19,3.99,1.19-3.98c.17-.56.61-1,1.17-1.17l3.98-1.19-3.98-1.19c-.56-.17-1-.6-1.17-1.16l-1.19-3.99-1.19,3.98c-.17.56-.61,1-1.17,1.17l-3.98,1.19Z"
    />
</svg>`;

const sparklesLargeIcon = {
    iconData: sparklesLargeSvg,
    iconWidth: 24,
    iconHeight: 24
};

export default sparklesLargeIcon;
